<template>
  <div class="home">
    <header-view curr="1"></header-view>
    <div class="body">
		
      <div class="toptitle">
      		<div class="left_c">
				<div class="redcon"></div>
				<span>捐助项目</span>
			</div>
			<div class="right_c">
				<div class="searchcon">
					 <input class="inputa" @input="changeinput" v-model="searchv" placeholder="请输入"/>
					 <img class="imgcon" src="../assets/searchimg.png" alt="" 
					 @click="changeinput"/>
				</div>
			</div>
      </div>
	  
      <div class="concent">
			<!-- <div class="item" v-for="(item, index) in Institutional">
				  <div class="image">
						<img class="imgcenter" :src="getFileAccessHttpUrl(item.indexPic)" alt="" />
				  </div>

				  <div class="name">{{ item.title }}</div>
				  <div @click="toprojectDetails(index,item)">
						<div class="btn hand">我要捐助</div>
				   </div>	
			</div> -->
			<div class="lista">
				  <div v-for="(item, index) in typelist" class="listsignle"
				  @click="changetab(index)">
					  <div :class="index == indexsign?'signlea_cur':'signlea'"> 
							<div>{{item}}</div> 
					  </div> 
					  <div :class="index == indexsign?'':'linecon'"></div>				
				  </div>
			</div>
			
			<div class="col_b" v-if="!ifshow">
				<div class="colbcar" v-for="(item,index) in Institutional"
				@click="toprojectDetails(index,item)">
					<div class="conductimg" v-if="item.state == 0">
						<img src="../assets/conductimg.png" alt="" />
					</div>
					<div class="img_con">
							<img :src="getFileAccessHttpUrl(item.indexPic)" alt="" />
					</div>
					
					<div>
						<div class="inform_con">							
							<div class="title">
								{{item.title?item.title.substring(0,10):'-'}}
							</div>
							<div class="xincon">	
								<div class="timeaddr">
									执行机构：{{item.reciveDept?item.reciveDept.substring(0,10):'-'}}
								</div>
								<div class="timeaddr">
									资助时间：{{item.startDate || '-'}}-{{item.endDate || '-'}}
								</div>
								<div class="timeaddr">
									资助地点：{{item.contributionFlow?item.contributionFlow.substring(0,10):'-'}}
								</div>
							</div>
						
							<div class="btncon">
								<div class="btndetail" v-if="item.state == 1">查看详情</div>
								<div class="btnjz" v-if="item.state == 0" @click="toprojectDetails(index,item)">我要捐助</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			
			<div class="concent_other" v-if="ifshow">
				<img class="imgcar" src="../assets/otherImg/no_data@2x.png" alt=""/>
			</div>
			
      </div>
	  
	  
      <zhini-pagination :key="componentKey"
        class="zhini-pagination"
        :currentPage="pageNo"
        :totalPage="totalPage"
        @pageNum="pageNum"
      ></zhini-pagination>
	  
    </div>
  </div>
</template>

<script>
import zhiniPagination from "../components/zhini-pagination.vue";
export default {
  name: "project",
  components: {
    zhiniPagination
  },
  data: function() {
    return {
		  Institutional: "",
		  pageNo: 1,
		  pageSize: 9,
		  totalPage: 0,
		  title: "",
		  ifshow:false,
		  
		  indexsign:0,
		  typelist:["全部","进行中","已结束"],
		  searchv:"",
		  componentKey: 0,        //用于强制刷新
    };
  },
  created() {
		var query = this.$route.query;
		this.title = query.title;
		this.getjzpageList();
	
  },
  mounted() {}, 
  methods: {
	//搜索
	changeinput(){
		this.getjzpageList();
	},
	
	//变化tab  
	changetab(index){
		this.indexsign = index;
		this.pageNo = 1;
		this.totalPage = 0;
		this.componentKey += 1;  
		this.getjzpageList();
	},
	
	//跳转捐赠
	toprojectDetails(indexsign,item){
		// var cdate = new Date();
		// if(cdate < new Date(item.startDate)){
		// 	this.$alert('活动未开始', '提示', {
		// 	  confirmButtonText: '确定',
		// 	  callback: action => {}
		// 	});
		// 	return;
		// }		
		// if(cdate > new Date(item.endDate)){
		// 	this.$alert('活动已结束', '提示', {
		// 	  confirmButtonText: '确定',
		// 	  callback: action => {}
		// 	});
		// 	return;
		// }
		this.$router.push({ path: '/projectDetails', query: {index:indexsign,id:item.id} });
	},
	
    getjzpageList() {
      var that = this;
      var obj = {
			pageNo: this.pageNo,
			pageSize: this.pageSize,
			title: this.searchv,
			column:"startDate",
			order:"desc",
      };
	  if(this.indexsign == 1){
		  obj.state = "0"
	  }else if(this.indexsign == 2){
		  obj.state = "1"
	  }
      // for (let j in obj) {
      //   obj[j] === "" ? delete obj[j] : "";
      // }
	   
      this.httpGet("web/thpDonationActivity/queryPageList", obj).then(res => {
        // console.log(res.result);
        // that.$store.commit("upProject", res.result.records);
        that.totalPage = Math.ceil(res.result.total / that.pageSize);
        that.Institutional = res.result.records;
		if(that.Institutional.length == 0){
			that.ifshow = true;
		}else{
			that.ifshow = false;
		}
      });
	  
	  window.pageYOffset = 0;
	  document.documentElement.scrollTop = 0;
	  document.body.scrollTop = 0;
    },
    pageNum(e) {
		window.pageYOffset = 0;
		document.documentElement.scrollTop = 0;
		document.body.scrollTop = 0;		  
		this.pageNo = e;
		this.getjzpageList();
    }
  },
  mounted() {}
};
</script>
<style scoped=" scoped" lang="scss">
.home {
  // background: #f4f5f9;
  width: 100%;
  // height: 100vh;
  min-height: 10rem;
  overflow: hidden;
  position: relative;
  .body {
    width: 11.52rem;
    min-height: 10rem;
    background: #ffffff;
    margin: 2.22rem auto 0;
    // padding: 0 0.7rem;
    overflow: hidden;
    .concent {
		width: 10.62rem;
		overflow: hidden;
		margin: 0 auto;
		min-height: 10rem;
		
		.concent_other{
			display: flex;
			width: 10.62rem;
			// align-items: center;
			justify-content: center;
			// border: 1px solid red;
			.imgcar{
				height: 2rem;
				width: 3rem;
				margin-top: 2rem;
			}
		}
		
		.lista{
			     margin-top: 0.2rem;
				 width: 100%;
				 height: 0.37rem;
				 background: #FBFBFB;
				 display: flex;
				 align-items: center;
				 cursor: pointer;
				 .listsignle{
					display: flex;
					align-items: center; 
				 }
				 .signlea{
					width: 1.07rem;
					height: 0.37rem;
					line-height: 0.37rem;
					text-align: center;
					color: #666666;
					font-size: 0.16rem;	
				 }
				 .signlea_cur{
					width: 1.07rem;
					height: 0.37rem;
					line-height: 0.37rem;
					text-align: center;
					background: #E70012; 
					color: #FFFFFF;
					font-size: 0.16rem;	
				 }
				 .linecon{
					 width: 0.01rem;
					 height: 0.17rem;
					 background: #666666;
					 opacity: 0.3;
				 }
				 
		}
		
		.col_b{
			// min-height: 5rem;
			display: flex;
			align-items: center;
			// justify-content: space-between;
			flex-wrap: wrap;
			margin-top: 0.2rem;
			margin-left: 0.1rem;
			// border: 1px solid red;
			.conductimg{
				margin-left: 0.2rem;
				position: absolute;
				img{
					width: 0.44rem;
					height: 0.5rem;
				}
			}
			.colbcar{
				cursor: pointer;
				width: 30%;
				margin-right: 0.3rem;
				margin-bottom: 0.3rem;
				min-height: 4.23rem;
				background: #F8F8F8;
				border: 1px solid #F1F1F1;
				// opacity: 0.3;
				.img_con{
					width: 100%;
					height: 1.92rem;
					img{
						width: 100%;
						height: 100%;
					}
				}
				
				.inform_con{
					margin-left: 0.25rem;
					margin-right: 0.25rem;
					// height: 2rem;
					// border: 1px solid red;
					.xincon{
						height: 1rem;
					}
					.title{
						font-size: 0.18rem;
						font-weight: 400;
						color: #333333;
						height: 0.6rem;
						line-height: 0.6rem;
					}
					.timeaddr{
						font-size: 0.14rem;
						font-weight: 400;
						color: #666666;
						min-height: 0.3rem;
						line-height: 0.3rem;
					}
					.btncon{
						height: 0.7rem;
						display: flex;
						align-items: center;
						justify-content: center;
						.btnjz{
							cursor: pointer;
							width: 0.96rem;
							height: 0.3rem;
							line-height: 0.3rem;
							text-align: center;
							background: #E41E15;
							border-radius: 0.15rem;
							font-size: 0.14rem;
							font-weight: 400;
							color: #FFFFFF;
						}
						.btndetail{
							cursor: pointer;
							width: 0.96rem;
							height: 0.3rem;
							line-height: 0.3rem;
							text-align: center;
							border: 1px solid #F80509;
							border-radius: 0.15rem;
							font-size: 0.14rem;
							font-weight: 400;
							color: #E41E15;
						}
					}
					
				}
			}					
		}
		
		
    }
	
	.toptitle{
		margin-left: 0.4rem;
		margin-right: 0.4rem;
		height: 0.6rem;
		border-bottom: 1px solid #ededed;
		display: flex;
		align-items: center;
		justify-content: space-between;
		.left_c{
			display: flex;
			align-items: center;
			.redcon{
				width: 0.05rem;
				height: 0.2rem;
				background: #E70012;
				margin-right: 0.2rem;
			}
			font-size: 0.18rem;
			font-weight: 400;
			color: #E61F26;
		}
		.right_c{
			// margin-right: 0.2rem;
			.searchcon{
				height: 0.4rem;
				line-height: 0.4rem;
				width: 2.68rem;
				background: #F1F1F1;
				border-radius: 0.15rem;
				padding-left: 0.2rem;
				padding-right: 0.2rem;
				display: flex;
				align-items: center;
				justify-content: space-between;
				.inputa{
					font-size: 0.14rem;
				}
				.imgcon{
					height:0.18rem;
					width: 0.18rem;
				}
			}
		}
	}
	
	.zhini-pagination {
	  // position: absolute;
	  // bottom: 0.55rem;
	  position:relative;
	  top:0rem;
	  width: 100%;
	  left: 0;
	}
	
	
  }
}
</style>
